// extracted by mini-css-extract-plugin
module.exports = {"root":"root___1QYBb","header":"header___2upiX","content":"content___3fklr"};